import { createFileRoute } from "@tanstack/react-router";
import { SubmitWizard } from "@/components/submit/SubmitWizard";
import type { Lang } from "@/lib/i18n";

const SUBMIT_META: Record<Lang, { title: string; desc: string }> = {
  en: { title: "Tell your story — MadCaptains", desc: "Anonymous-first submission. No account required." },
  ru: { title: "Расскажите свою историю — MadCaptains", desc: "Анонимная отправка. Аккаунт не требуется." },
  fr: { title: "Racontez votre histoire — MadCaptains", desc: "Soumission anonyme par défaut. Aucun compte requis." },
  es: { title: "Cuente su historia — MadCaptains", desc: "Envío anónimo por defecto. No se requiere cuenta." },
  zh: { title: "讲述您的经历 — MadCaptains", desc: "默认匿名提交，无需账户。" },
  ar: { title: "احكِ قصتك — MadCaptains", desc: "تقديم مجهول الهوية افتراضيًا. لا حاجة إلى حساب." },
};

// §6: NO analytics, NO fingerprinting, NO IP logging on /submit.
// `noindex` keeps the submission flow out of search results — the public
// story archive is what gets indexed.
export const Route = createFileRoute("/$lang/submit")({
  head: ({ params }) => {
    const m = SUBMIT_META[params.lang as Lang] ?? SUBMIT_META.en;
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { name: "robots", content: "noindex,nofollow" },
        { property: "og:url", content: `/${params.lang}/submit` },
      ],
      links: [{ rel: "canonical", href: `/${params.lang}/submit` }],
    };
  },
  component: SubmitPage,
});

function SubmitPage() {
  const { lang } = Route.useParams();
  return <SubmitWizard lang={lang as Lang} />;
}